// #XXXXXXの16進数カラーコードをRGBA形式に変換する
export function hexToRgba(hex: string, alpha: number): string {
  const result = hex.match(/\w\w/g);
  if (!result) return "rgba(0,0,0,1)";
  const [r, g, b] = result.map((x) => parseInt(x, 16));
  return `rgba(${r},${g},${b},${alpha})`;
}
